import { Injectable } from "@angular/core";
import { environment } from '../../../environments/environment'

@Injectable()
export class ConfigService {
  _apiURI: string;

  constructor() {
    // this._apiURI = "http://dcl_duloren2.ngrok.io/svc/api";
    //this._apiURI = "http://dcl_duloren.ngrok.io/svc/api";
    // this._apiURI = "http://localhost/svc/api";
    this._apiURI = environment.api_url;
    // this._apiURI =  window.location.origin + '/svc/api';
  }

  getApiURI() {
    return this._apiURI;
  }
}
